import { AfterViewInit, Component, Input, ViewChild } from "@angular/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs/operators";
import { EventService } from "../event-service/event.service";
import { OnboardingTaskService } from "../models/onboarding-task.service";
import { OnboardingTaskStateService } from "./onboarding-task-state.service";

@Component({
  selector: "ab-onboarding-callout",
  templateUrl: "./onboarding-callout.component.html",
})
export class OnboardingCalloutComponent implements AfterViewInit {
  @Input() public className: string;
  @Input() public project: any;
  @Input() public user?: any;
  @Input() public group?: any;
  @ViewChild("popoverInstance") public popoverInstance: NgbPopover;

  constructor(
    private eventService: EventService,
    private onboardingTaskStateService: OnboardingTaskStateService,
    private onboardingTaskService: OnboardingTaskService,
  ) {}

  public ngAfterViewInit() {
    // Not all views (such as /projects) have a project.
    if (!this.project) {
      return;
    }

    this.onboardingTaskStateService
      .initForProject(this.project)
      .subscribe(() => {
        const callout = this.onboardingTaskStateService.calloutTask;
        if (!callout) {
          return;
        }
        if (callout.class_name === this.className) {
          this.popoverInstance.open();
        }
      });
  }

  // TODO: [onboarding] can this be solved in a less hacky way? We need to a)
  // make an API request to dismiss the callout b) navigate to the link.
  public dismissAndFollowLink(event: any) {
    event.preventDefault();
    this.dismiss(event);
    // Give the browser time to fire the API request before following the link.
    setTimeout(() => {
      this.locationReplace(event.target.href);
    });
  }

  public dismiss(event: any) {
    const callout = this.onboardingTaskStateService.calloutTask;
    if (!callout) {
      return;
    }
    if (callout.class_name !== this.className) {
      return;
    }

    event.stopPropagation();
    this.popoverInstance.close();
    this.dismissTask(callout);
  }

  // This is by convention, ShowX callouts are configured in the backend to be
  // discarded completely when dismissed rather than appear in the checklist.
  public dismissLinkText() {
    const callout = this.onboardingTaskStateService.calloutTask;
    if (callout.class_name.startsWith("Show")) {
      return "Close";
    } else {
      return "Do this later";
    }
  }

  // Provide our own wrapper function to make it easily mocked in specs.
  public locationReplace(url: string) {
    window.location.replace(url);
  }

  private dismissTask(callout: any) {
    this.onboardingTaskService
      .dismissCallout({ projectId: this.project.id, taskId: callout.id })
      .pipe(
        finalize(() => {
          this.onboardingTaskStateService.reloadTasks().subscribe(() => {
            this.eventService.publish("dismissed-callout");
          });
        }),
      )
      .subscribe();
  }
}
